import {
    server
} from "@/api";


export const create = async (order) => {
    return await server().post('api/orders', order)
}

export const paginate = async (params) => {
    return await server().get('api/orders', { params });
}

export const products = async (params) => {
    return await server().get('api/products/for-orders', { params });
}

export const update = async (id, order) => {
    return await server().post(`api/orders/${id}`, order);
}

export const call = async (id, type = 'agent') => {
    return await server().post(`api/orders/${id}/calls`, { type });
}

export const handle = async () => {
    return await server().get(`api/orders/handle`);
}

export const history = async (id) => {
    return await server().get(`api/orders/${id}/history`);
}

export const returnReasonRead = async (id) => {
    return await server().post(`api/orders/${id}/return-reason-read-at`);
}

export default {
    create,
    paginate,
    update,
    products,
    history,
    call,
    handle,
    returnReasonRead
}